import { useSelector } from "react-redux";
import { RootReduxState } from "~/modules/app/components/ReduxProvider/types";
import { DebugStoreState } from "../store/types";

// // // //

/**
 * useDebug
 * React Hook that exposes User redux state
 */
export function useDebug(): DebugStoreState {
    const { debug_preview_features } = useSelector(
        (state: RootReduxState) => state.debug,
    );

    return { debug_preview_features };
}
